import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import NotificationsSettingsPage, { getDefaultPageUI } from "components/pages/NotificationsSettingsPage";
import { getDefaultAddPhone } from "components/workflows/AddPhoneContactMethodModalWorkflow";
import Classes from "model";

export default function CaptureNotifiPhoneEntered(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, controller);

    const modalData = BCMSStateManagerCRUD.init(getDefaultAddPhone("addPhoneWorkflow", undefined))
        .update([ "data", "info", "value" ], "231-256-7890")
        .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "modal", "id" ], "AddContactMethodModal")
        .update([ "modal", "data" ], { workflowType: "addPhoneWorkflow", values: modalData })
        .submit();

    return <NotificationsSettingsPage ui={ ui } />
}